import clsx from 'clsx';
import Information from '~/icons/information.svg';
import Typography from '~/shared/components/Typography/Typography';
import styles from './InfoMessage.module.scss';

type Props = {
    children: string;
    className?: string;
    tone?: 'neutral' | 'warning';
    // Announce the message to screen readers when it appears (for messages inserted in response
    announceToScreenReader?: boolean;
};

export const InfoMessage = ({
    children,
    className,
    tone = 'neutral',
    announceToScreenReader = false,
}: Props) => (
    <div
        className={clsx(styles.infoMessage, tone === 'warning' && styles.warning, className)}
        role={announceToScreenReader ? 'status' : undefined}
    >
        <Information aria-hidden="true" className={styles.icon} />
        <Typography as="p" variant="paragraph-S">
            {children}
        </Typography>
    </div>
);
